export const delay = (duration) =>
  new Promise((resolve) => setTimeout(resolve, duration));



// WEBPACK FOOTER //
// ./src/delay.js